import { trackerCore, version, } from "@snowplow/tracker-core";
export const tracker = (emitters, namespace, appId, encodeBase64) => new NodeTracker(emitters, namespace, appId, encodeBase64);
/**
 * Snowplow Node.js Tracker
 */
export class NodeTracker {
    /**
     * @param string - or array emitters The emitter or emitters to which events will be sent
     * @param string - namespace The namespace of the tracker
     * @param string - appId The application ID
     * @param boolean - encodeBase64 Whether unstructured events and custom contexts should be base 64 encoded
     */
    constructor(emitters, namespace, appId, encodeBase64) {
        /**
         * Send the payload for an event to the endpoint
         *
         * @param payload - Dictionary of name-value pairs for the querystring
         */
        this.sendPayload = (payload) => {
            this.addUserInformation(payload);
            const builtPayload = payload.build();
            for (let i = 0; i < this.allEmitters.length; i++) {
                this.allEmitters[i].input(builtPayload);
            }
        };
        this.addUserInformation = (payload) => {
            payload.add("duid", this.domainUserId);
            payload.add("nuid", this.networkUserId);
            payload.add("sid", this.sessionId);
            payload.add("vid", this.sessionIndex && Number(this.sessionIndex));
        };
        this.setDomainUserId = function (userId) {
            this.domainUserId = userId;
        };
        this.setNetworkUserId = function (userId) {
            this.networkUserId = userId;
        };
        this.setSessionId = function (currentSessionId) {
            this.sessionId = currentSessionId;
        };
        this.setSessionIndex = function (currentSessionIndex) {
            this.sessionIndex = currentSessionIndex;
        };
        this.flush = function () {
            for (const emitters of this.allEmitters) {
                emitters.flush();
            }
        };
        if (Array.isArray(emitters)) {
            this.allEmitters = emitters;
        }
        else {
            this.allEmitters = [emitters];
        }
        encodeBase64 = encodeBase64 !== false;
        const core = trackerCore({
            base64: encodeBase64,
            callback: this.sendPayload,
        });
        core.setPlatform("srv"); // default platform
        core.setTrackerVersion("node-" + version);
        core.setTrackerNamespace(namespace);
        core.setAppId(appId);
        Object.assign(this, core);
    }
}
